var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1722 0.799805H0.227778C0.101931 0.799805 0 0.900774 0 1.02537V1.4765C0 1.60109 0.101931 1.70206 0.227778 1.70206H0.911111V9.79591C0.911111 10.2934 1.3194 10.6984 1.82222 10.6984H7.74444V12.0802L5.30551 14.4959C5.21668 14.5839 5.21668 14.7268 5.30551 14.8148L5.62753 15.1338C5.64865 15.1547 5.67375 15.1713 5.70138 15.1826C5.72901 15.194 5.75863 15.1998 5.78855 15.1998C5.81846 15.1998 5.84808 15.194 5.87571 15.1826C5.90334 15.1713 5.92844 15.1547 5.94956 15.1338L8.2 12.9051L10.4502 15.1338C10.4713 15.1547 10.4964 15.1713 10.524 15.1826C10.5516 15.194 10.5813 15.1998 10.6112 15.1998C10.6411 15.1998 10.6707 15.194 10.6983 15.1826C10.726 15.1713 10.7511 15.1547 10.7722 15.1338L11.0942 14.8148C11.183 14.7268 11.183 14.5839 11.0942 14.4959L8.65556 12.0802V10.6984H14.5778C15.0806 10.6984 15.4889 10.2934 15.4889 9.79591V1.70234H16.1722C16.2981 1.70234 16.4 1.60137 16.4 1.47678V1.02537C16.4 0.900774 16.2981 0.799805 16.1722 0.799805ZM14.5778 9.79985H1.82222V1.69981H14.5778V9.79985Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.b6098848e254d8009377add4363021c4.svg";
export { ForwardRef as ReactComponent };